import { Checklist } from "interfaces/kpis";

export const compareChecklistsArchivedLast = (
  a: Checklist,
  b: Checklist
): number => {
  const aIsArchived = a.status === "archived";
  const bIsArchived = b.status === "archived";

  // Both or neither are archived, compare alphabetically
  if ((aIsArchived && bIsArchived) || !(aIsArchived || bIsArchived))
    return a.name > b.name ? 1 : -1;

  // Archived checklists appear after non-archived
  return aIsArchived ? 1 : -1;
};
